import React from "react";
import "./LocalityOption.scss";

const LocalityOption = ({
  children,
  innerRef,
  innerProps,
  isFocused,
  ...props
}) => {
  const optionData = props.data.data || props.data;
  const parentName = props.data.parentHierarchy;
  const isCreateOption = props.data.__isNew__;

  return (
    <div
      className={`localityOption ${isFocused ? "isFocused" : ""}`}
      ref={innerRef}
      {...innerProps}
    >
      <div className="optionInfo">
        <div className="contentName">
          <span className="optionName">{`${
            optionData.name ?? optionData.label
          }`}</span>

          {!isCreateOption && optionData.isFictional && (
            <>
              <span className="option-separator">{` - `}</span>
              <span className="fictional">{`Fictício`}</span>
            </>
          )}

          {!isCreateOption && parentName && (
            <>
              <span className="option-separator">{` - `}</span>
              <span className="parent">{parentName}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocalityOption;
